import { theme } from '@lmc/ui-kit'
import { Heading, Text } from '@lmc/ui-kit/src/general'
import { Warning } from '@lmc/ui-kit/src/systemIcons'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type RotaWarningBoxProps = {
  name: string
  status: string
  confirmButtonText?: string
}

/**
 * Reusable warning box for rota cancellation warnings.
 * Used in forms where a status change will cancel future rota visits.
 */
const RotaWarningBox = ({
  name,
  status,
  confirmButtonText = 'OK'
}: RotaWarningBoxProps) => {
  const { t } = useTranslation()

  return (
    <WarningContainer data-testid="rota-warning-box">
      <WarningHeader>
        <Warning color={theme.color.status.warning} size={20} />
        <Heading level={5}>{t('DEACTIVATE_SU_TITLE')}</Heading>
      </WarningHeader>
      <WarningText>
        {t('DEACTIVATE_SU_DESCRIPTION', { name, status })}
      </WarningText>
      <WarningPrompt>
        {t('DEACTIVATE_SU_MORE_INFO', { name }).replace(
          'OK',
          confirmButtonText
        )}
      </WarningPrompt>
    </WarningContainer>
  )
}

const WarningContainer = styled.div`
  background-color: ${(props) => props.theme.color.neutral.color9};
  border: 1px solid ${(props) => props.theme.color.status.warning};
  border-radius: ${(props) => props.theme.properties.borderRadius.small};
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const WarningHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const WarningText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color3};
`

const WarningPrompt = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color3};
  font-weight: 500;
  margin-top: 8px;
`

export default RotaWarningBox
